import React from 'react';
import { InputAdornment, Paper, Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';
import { GridView, Search, ViewList } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ProductViewMode, SearchFiltersProps } from './types';

export const SearchFilters: React.FC<SearchFiltersProps> = ({
  query,
  onQueryChange,
  viewMode,
  onViewModeChange,
}) => {
  const { t } = useTranslation();

  const handleViewModeChange = (_: React.MouseEvent<HTMLElement>, nextViewMode: ProductViewMode | null) => {
    if (nextViewMode) {
      onViewModeChange(nextViewMode);
    }
  };

  return (
    <Paper sx={{ p: 2, mb: 3, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'stretch', sm: 'center' }}>
        <TextField
          placeholder={t('products.searchPlaceholder')}
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          size="small"
        />
        <ToggleButtonGroup
          exclusive
          size="small"
          value={viewMode}
          onChange={handleViewModeChange}
          aria-label={t('products.viewMode')}
          sx={{
            alignSelf: { xs: 'flex-start', sm: 'center' },
            '& .MuiToggleButton-root': {
              width: 40,
              height: 38,
              color: 'text.secondary',
              borderColor: 'divider',
              '&.Mui-selected': {
                color: 'primary.dark',
                bgcolor: '#edf7ef',
              },
            },
          }}
        >
          <ToggleButton value="list" aria-label={t('products.listView')}>
            <Tooltip title={t('products.listView')}>
              <ViewList fontSize="small" />
            </Tooltip>
          </ToggleButton>
          <ToggleButton value="cards" aria-label={t('products.cardView')}>
            <Tooltip title={t('products.cardView')}>
              <GridView fontSize="small" />
            </Tooltip>
          </ToggleButton>
        </ToggleButtonGroup>
      </Stack>
    </Paper>
  );
};

